{
  "allDataFlag": true,
  "list": [
    {
      "agentId": 114679,
      "agentNo": "00049584",
      "agentName": "Nové Zámky Oblastné riaditeľstvo",
      "agentStatus": "RZ",
      "agentChannel": "US",
      "agentMobilAgn": null,
      "agentEmailAgn": null,
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1046297325,
      "policyId": 957534701,
      "policyNumber": "0303298657",
      "dateBegin": "2010-12-01T00:00:00.000+01:00",
      "dateEnd": "2042-11-30T00:00:00.000+01:00",
      "lobId": 7,
      "lobLabel": "LI"
    },
    {
      "agentId": 114679,
      "agentNo": "00038311",
      "agentName": "Andrea Vidová",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421907742782",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1052939216,
      "policyId": 1034232937,
      "policyNumber": "7600223852",
      "dateBegin": "2021-04-18T00:00:00.000+02:00",
      "dateEnd": null,
      "lobId": 9,
      "lobLabel": "PP"
    },
    {
      "agentId": 114679,
      "agentNo": "00038311",
      "agentName": "Andrea Vidová",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421907742782",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1032990027,
      "policyId": 957190543,
      "policyNumber": "0356039719",
      "dateBegin": "2010-07-27T00:00:00.000+02:00",
      "dateEnd": "2042-07-26T00:00:00.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    },
    {
      "agentId": 278561,
      "agentNo": "00044804",
      "agentName": "R.I.C. Slovakia, s.r.o.",
      "agentStatus": "MA",
      "agentChannel": "MA",
      "agentMobilAgn": "+421905552551",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1042911698,
      "policyId": 849953382,
      "policyNumber": "70091347",
      "dateBegin": "2003-10-17T00:00:00.000+02:00",
      "dateEnd": "2022-10-17T23:59:59.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    },
    {
      "agentId": 278561,
      "agentNo": "00049591",
      "agentName": "Topoľčany Oblastné riaditeľstvo",
      "agentStatus": "RZ",
      "agentChannel": "US",
      "agentMobilAgn": null,
      "agentEmailAgn": null,
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 873259353,
      "policyId": 1787002,
      "policyNumber": "840872721",
      "dateBegin": "1998-05-22T00:00:00.000+02:00",
      "dateEnd": null,
      "lobId": 9,
      "lobLabel": "PP"
    },
    {
      "agentId": 391244,
      "agentNo": "00073009",
      "agentName": "Martin Kinček s.r.o.",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421905453879",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1051670898,
      "policyId": 853347161,
      "policyNumber": "1000599266",
      "dateBegin": "2002-01-01T00:00:00.000+01:00",
      "dateEnd": null,
      "lobId": 8,
      "lobLabel": "MT"
    },
    {
      "agentId": 106889,
      "agentNo": "00038311",
      "agentName": "Andrea Vidová",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421907742782",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1018106837,
      "policyId": 1017233794,
      "policyNumber": "0358253169",
      "dateBegin": "2012-07-03T00:00:00.000+02:00",
      "dateEnd": "2027-07-02T00:00:00.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    },
    {
      "agentId": 106889,
      "agentNo": "00038311",
      "agentName": "Andrea Vidová",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421907742782",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1018106995,
      "policyId": 1017233793,
      "policyNumber": "0358253151",
      "dateBegin": "2012-07-03T00:00:00.000+02:00",
      "dateEnd": "2028-07-02T00:00:00.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    },
    {
      "agentId": 45402,
      "agentNo": "00024646",
      "agentName": "Miroslav Brna",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421915732876",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1042911821,
      "policyId": 853643915,
      "policyNumber": "38985781",
      "dateBegin": "2002-07-31T00:00:00.000+02:00",
      "dateEnd": "2021-07-31T23:59:59.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    }
  ],
  "pagination": {
    "page": 0,
    "maxPage": 1,
    "maxItems": 5,
    "wsItemsPerPage": 100
  }
}
